<template>
  <div class="WX-78">
    <ol>
      <li>
        <div>심장을 제일 먼저 정해진 개수만큼 만드는 사람이 승자입니다</div>
        <div>기간 내에 개수를 채운 사람이 없다면 가장 많이 만든 사람이 승자입니다</div>
      </li>
      <li>
        <div>왼쪽에 보이는 벽 안에 기어가 숨어있습니다</div>
        <div>개수는 랜덤이니 WX-78에게 먹여 체력을 보충해 더 많은 심장을 만드세요</div>
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'WX-78'
}
</script>


// WEBPACK FOOTER //
// src/components/Mission/WX-78.vue